import React, { useMemo } from 'react';
import TreeSelectDropdown from '../dropdowns/treeSelectDropdown';
import { renderNodeIconAndName } from './util';
import { RealAssetDeploymentWithChildrenResponse } from '../../apiClient';


interface DeploymentTreeDropdownProps {
    deployment: RealAssetDeploymentWithChildrenResponse;
    onOptionToggle: (selectedIds: string[]) => void;
    selectedIds: string[];
}

const DeploymentTreeDropdown: React.FC<DeploymentTreeDropdownProps> = ({
    deployment,
    onOptionToggle,
    selectedIds,
}) => {
    const treeData = useMemo(() => {
        const createTreeNode = (dep: any): any => ({
            public_id: dep.public_id,
            name: dep.name,
            children: (dep.child_deployments || []).map(createTreeNode),
            type: dep.real_asset.type,
        });

        return [createTreeNode(deployment)];
    }, [deployment]);

    return (
        <TreeSelectDropdown
            label="Cameras/Instruments"
            options={treeData}
            selectedIds={selectedIds}
            onOptionToggle={onOptionToggle}
            isLoading={false}
            enableSearch={true}
            initiallyExpanded={true}
            renderNode={(node: any) => renderNodeIconAndName(node, (node: any) => node.type)}
        />
    );
};

export default DeploymentTreeDropdown;